import { Fragment, useState, useEffect, forwardRef } from 'react';
import styles from './Groups.module.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import Dialog from '@material-ui/core/Dialog';
import Container from '@material-ui/core/Container';
import { CircularProgress, Slide } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import background from 'assets/images/test.jpg';
import GroupItem from './GroupItem/GroupItem';
import { useGroupAPI } from 'pages/PhotoAdmin/SelectShop/hooks/useGroupAPI';
import LoadIndicator from 'components/common/LoadIndicator/LoadIndicator';
import GroupDetails from 'components/PhotoAdminComponents/Group/GroupDetails/GroupDetails';
import AddGroupCard from 'components/PhotoAdminComponents/Group/AddGroupCard/AddGroupCard';
import { useSelector } from 'react-redux';
import QueryBuilder from 'components/common/QueryBuilder/QueryBuilder';
import { useLocation, useNavigate } from 'react-router-dom';
import { useModifierApi } from '../Templates/hooks/useModifierApi';
import { useTranslation } from 'react-i18next';
export const Transition = forwardRef((props, ref) => {
  return <Slide direction='left' ref={ref} {...props} />;
});

const Groups = () => {
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();
  const { search } = useLocation();
  const [showAll, setShowAll] = useState(false);

  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);

  const { fetchGroupsNew, groupsLength, groups, groupLoading, loading, putGroup, fetchAllGroups } = useGroupAPI();
  const { modifiers, getModifiers } = useModifierApi();
  const { t } = useTranslation();
  const [detailsOpen, setDetailsOpen] = useState(false);

  const toggleDetailsOpen = () => {
    setDetailsOpen(!detailsOpen);
  };

  useEffect(() => {
    if (shopId) {
      fetchGroupsNew({ queryString: '' });
      fetchAllGroups();
      getModifiers();
    }
  }, [shopId]);

  const refresh = () => {
    fetchGroupsNew({ queryString: search });
    fetchAllGroups();
  };
  useEffect(() => {
    refresh();
    let queryParams = new URLSearchParams(search);

    if (queryParams.get('size') !== groupsLength) {
      setShowAll(false);
    }
  }, [search]);
  const resetQueryString = () => {
    navigate(`/shops/${shopId}/administration/galleries`);
  };

  useEffect(() => {
    if (
      // (user?.ownedShops?.find((shop) => shop.id == shopId)?.isDemo && user?.ownedShops[0]?.metrics?.groupCount >= 6) ||
      user?.ownedShops[0]?.metrics?.groupCount >= shopTier?.galleryLimit
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [user, shopTier]);

  return (
    <div className={styles.root}>
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <Typography style={{ fontFamily: 'var(--font-main)' }} variant='body1'>
          {t('groups.title')}
        </Typography>
      </Breadcrumbs>
      <CssBaseline />
      <Container maxWidth={'xl'}>
        <main className={styles.content}>
          <div className={styles.newGroupContainer}>
            {/* <Button
              onClick={() => setDetailsOpen(true)}
              className={classes.newGroupBtn}
              variant="contained"
              component="button"
            >
              Iskola hozzáadása
            </Button> */}
            {loading && (
              <div className={styles.updateIndicator}>
                {t('groups.refresh')}
                <CircularProgress
                  size={20}
                  style={{
                    color: 'var(--primary-background-primary)',
                    marginLeft: '0.5rem'
                  }}
                />
              </div>
            )}
          </div>
          {/* <TablePagination
            hidden={groups?.length <= 10 || groups?.length === undefined}
            component="div"
            count={groups?.length}
            page={currentPage}
            onPageChange={handleChangePage}
            rowsPerPage={pageSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={"Iskolák egy oldalon:"}
          /> */}
          <QueryBuilder
            itemsLength={groupsLength}
            siteType={'group'}
            showAll={showAll}
            reset={resetQueryString}
            refresh={refresh}>
            <div className={styles.groupsContainer}>
              {groupLoading ? (
                <LoadIndicator color={'var(--primary-light)'} height={300} />
              ) : (
                <>
                  <AddGroupCard
                    toggleCreateModal={() => setDetailsOpen(true)}
                    isSchool={true}
                    disabled={disabled}
                    isDemo={user?.ownedShops?.find((shop) => shop.id == shopId)?.isDemo}
                    modifiers={modifiers}
                  />

                  {groups?.map((group) => {
                    return (
                      <Fragment key={`group_${group.id}`}>
                        {group.belongsTo ? (
                          <Fragment />
                        ) : (
                          <GroupItem
                            shopId={shopId}
                            disabled={false}
                            isSchool={true}
                            refetch={refresh}
                            group={group}
                            imgSrc={background}
                            putGroup={putGroup}
                          />
                        )}
                      </Fragment>
                    );
                  })}
                </>
              )}
            </div>
          </QueryBuilder>
          {/* <TablePagination
            hidden={groups?.length === undefined}
            component="div"
            count={groups?.length}
            page={currentPage}
            onPageChange={handleChangePage}
            rowsPerPage={pageSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={"Iskolák egy oldalon:"}
          /> */}
          <Dialog
            open={detailsOpen}
            TransitionComponent={Transition}
            keepMounted
            maxWidth={'md'}
            onClose={toggleDetailsOpen}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'>
            <GroupDetails
              shopId={shopId}
              isSchool={true}
              currentGroup={null}
              belongsTo={null}
              toggle={toggleDetailsOpen}
              createModal={true}
              refresh={() => {
                fetchGroupsNew({ queryString: '' });
                fetchAllGroups();
              }}
            />
          </Dialog>
        </main>
      </Container>
    </div>
  );
};

export default Groups;
